import { useMemo, useState } from 'react';
import { Toast } from 'antd-mobile';
import { useNavigate, useSearchParams } from 'react-router-dom';
import i18n from '../../../i18n';
import { authApi } from '../../../api/auth';
import { useAuthStore } from '../../../stores/auth.store';
import { RegisterFormValues } from './types';

export function useRegisterModel() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const login = useAuthStore((state) => state.login);
  const [loading, setLoading] = useState(false);

  const referralCode = useMemo(() => searchParams.get('ref') || '', [searchParams]);

  const submit = async (values: RegisterFormValues) => {
    if (values.password !== values.confirm) {
      Toast.show({ icon: 'fail', content: i18n.t('auth:register.passwordMismatch') });
      return;
    }

    setLoading(true);
    try {
      const response = await authApi.register({
        username: values.username.trim(),
        password: values.password,
        display_name: values.display_name.trim(),
        referral_code: values.referral_code?.trim() || undefined,
      });
      const payload = response.data.data;
      login(payload.user, payload.accessToken, payload.refreshToken);
      Toast.show({ icon: 'success', content: i18n.t('auth:register.successToast') });
      navigate('/', { replace: true });
    } catch (error: any) {
      Toast.show({
        icon: 'fail',
        content: error?.response?.data?.error?.message || i18n.t('auth:register.failedToast'),
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    referralCode,
    submit,
  };
}
